export const supplierPricingHe = {
  "title": "המחירון שלי",
  "subtitle": "המחירים כאן יחולו על כל הזמנה חדשה, אלא אם הוגדר ללקוח מחירון מותאם.",
  "lastUpdated": "עדכון אחרון: {{date}}, {{user}}",
  "save": "שמור שינויים",
  "saving": "שומר...",
  "discard": "בטל שינויים",
  "exportExcel": "ייצוא לאקסל",
  "history": "היסטוריית שינויים",
  "unsaved": "יש שינויים שלא נשמרו",
  "tabs": {
    "default": "מחירון ברירת מחדל",
    "customers": "מחירונים מותאמים ללקוחות ({{count}})"
  },
  "diameter": {
    "title": "מחיר חומר לפי קוטר",
    "subtitle": "₪ לטון, לפני מע״מ. אפשר למלא ערך אחד וללחוץ ״מלא חסרים״.",
    "col": "קוטר (מ״מ)",
    "ribbed": "מצולע ₪/טון",
    "smooth": "עגול ₪/טון",
    "weldableExtra": "תוספת רתיך ₪/טון",
    "fillMissing": "מלא חסרים",
    "addDiameter": "+ הוסף קוטר",
    "missing": "חסר מחיר"
  },
  "processing": {
    "title": "עיבוד ויחידות",
    "subtitle": "מחיר לעבודה - מתווסף למחיר החומר",
    "cut": "חיתוך",
    "bend": "כיפוף",
    "unitPrice": "חישוקים / יחידות",
    "minUnit": "מינימום ליחידה",
    "shortRulePrefix": "צורה שאורכה עד",
    "shortRuleSuffix": "ס״מ תחושב כיחידה"
  },
  "transport": {
    "title": "הובלה",
    "subtitle": "עלות משלוח לאתר",
    "method": "שיטת חישוב",
    "methods": {
      "per_ton": "לפי טון",
      "fixed": "סכום קבוע",
      "none": "ללא הובלה"
    },
    "price": "מחיר",
    "freeAbove": "הובלה חינם מעל",
    "minimum": "מינימום להובלה"
  },
  "general": {
    "title": "פחת ומע״מ",
    "vat": "מע״מ",
    "waste": "פחת ברירת מחדל",
    "validity": "תוקף הצעת מחיר",
    "days": "{{count}} ימים"
  },
  "exceptions": {
    "title": "חריגים לפי צורה",
    "subtitle": "צורות שמחושבות אחרת מהמחירון הכללי. סוג החיוב נקבע אוטומטית - אפשר לשנות כאן רק כשצריך.",
    "add": "+ הוסף חריג לצורה",
    "sketch": "שרטוט",
    "shape": "צורה",
    "chargeType": "סוג חיוב",
    "processing": "מחיר עיבוד",
    "unitPrice": "מחיר ליחידה",
    "appliesTo": "חל על",
    "all": "כל הלקוחות",
    "selected": "לקוחות נבחרים",
    "modalTitle": "חריג מחיר לצורה",
    "save": "שמור חריג",
    "delete": "מחיקה",
    "confirmDelete": "למחוק את החריג?"
  },
  "charge": {
    "bend": "כיפוף",
    "cut": "חיתוך",
    "unit": "יחידה",
    "none": "ללא עיבוד"
  },
  "units": {
    "perTon": "₪ לטון",
    "ils": "₪",
    "perUnit": "₪ ליחידה",
    "cm": "ס״מ",
    "ton": "טון",
    "percent": "%"
  },
  "customers": {
    "add": "+ מחירון ללקוח",
    "search": "חיפוש לקוח",
    "customer": "לקוח",
    "type": "סוג",
    "discount": "הנחה כללית",
    "special": "מחירים מיוחדים",
    "transport": "הובלה",
    "updated": "עודכן",
    "edit": "עריכה",
    "custom": "מותאם",
    "rest": "שאר הלקוחות משלמים לפי מחירון ברירת המחדל.",
    "diametersCount": "{{count}} קטרים"
  },
  "customerTab": {
    "customMode": "מחירון מותאם ללקוח",
    "customModeDesc": "מחירים והנחות מיוחדים ללקוח הזה",
    "defaultMode": "מחירון ברירת מחדל",
    "defaultModeDesc": "הלקוח משלם לפי המחירון הכללי",
    "discount": "הנחה כללית על חומר",
    "waste": "פחת",
    "paymentTerms": "תנאי תשלום",
    "terms": {
      "cash": "מזומן",
      "net30": "שוטף + 30",
      "net60": "שוטף + 60",
      "net90": "שוטף + 90"
    },
    "transport": "הובלה",
    "transportModes": {
      "pricelist": "לפי המחירון",
      "custom": "מותאם"
    },
    "overridesTitle": "מחירים מיוחדים לפי קוטר (גוברים על ההנחה הכללית)",
    "addOverride": "+ מחיר מיוחד לקוטר",
    "general": "מחירון כללי ₪/טון",
    "forCustomer": "מחיר ללקוח ₪/טון",
    "diff": "הפרש",
    "restRow": "כל השאר",
    "note": "המחירון יחול על הזמנות חדשות של הלקוח. הזמנות שכבר נוצרו לא ישתנו.",
    "cancel": "ביטול",
    "save": "שמור מחירון ללקוח",
    "tabDetails": "פרטים",
    "tabPricing": "תמחור"
  },
  "order": {
    "chooseList": "בחרו מחירון",
    "customerList": "מחירון לקוח",
    "explicitSelection": "בחרו מחירון והפיקו הצעת מחיר כדי להציג מחירים.",
    "noCustomList": "ללקוח זה אין מחירון מותאם. ניתן להשתמש במחירון הכללי.",
    "customerLoadFailed": "לא ניתן לטעון מחירון לקוח. ניתן להשתמש במחירון הכללי.",
    "selectionFailed": "בחירת המחירון נכשלה. נסו שוב.",
    "generationFailed": "הפקת הצעת המחיר נכשלה. לא מוצגים מחירים חדשים.",

    "exportPdf": "הפק PDF",
    "exportPricedPdf": "הפק PDF עם מחיר",
    "priceList": "מחירון להזמנה",
    "showPrices": "הצג מחירים בטבלה",
    "priceCol": "מחיר (₪)",
    "chargeCol": "עיבוד",
    "summary": "תמחור",
    "material": "חומר ({{tons}} טון)",
    "bend": "כיפוף",
    "cut": "חיתוך",
    "units": "יחידות",
    "transport": "הובלה",
    "discount": "הנחת לקוח {{pct}}%",
    "subtotal": "סה״כ לפני מע״מ",
    "vat": "מע״מ {{pct}}%",
    "total": "סה״כ לתשלום",
    "createQuote": "הפק הצעת מחיר",
    "analysis": "ניתוח כספי",
    "missingPrices": "חסר מחיר ל-{{count}} שורות - עדכנו את המחירון",
    "saveToApplyServer": "המחירון שנבחר יישמר עם ההזמנה. יש לשמור את ההזמנה לפני הפקת PDF עם מחיר."
  },
  "analysis": {
    "title": "ניתוח כספי להזמנה",
    "subtotal": "סה״כ לפני מע״מ",
    "avgPerTon": "מחיר ממוצע לטון",
    "processing": "עיבוד ויחידות",
    "transport": "הובלה",
    "split": "פילוח הסכום",
    "byDiameter": "פירוט לפי קוטר",
    "weight": "משקל (טון)",
    "total": "סה״כ ₪",
    "print": "הדפסה",
    "note": "* לפני הובלה והנחת לקוח. הערכים מחושבים לפי המחירון שנבחר בהזמנה."
  },
  "quote": {
    "preview": "תצוגת הצעת מחיר",
    "download": "הורדת הצעת מחיר PDF",
    "downloadFailed": "הורדת הצעת המחיר נכשלה. נסו שוב.",

    "title": "הצעת מחיר מס׳ {{no}}",
    "date": "תאריך",
    "validUntil": "בתוקף עד",
    "order": "הזמנה",
    "to": "לכבוד",
    "site": "אתר",
    "delivery": "אספקה",
    "terms": "תנאי תשלום",
    "description": "תיאור",
    "qty": "כמות",
    "weight": "משקל ק״ג",
    "perTon": "₪ לטון",
    "sum": "סה״כ ₪",
    "notes": [
      "המחירים בש״ח ואינם כוללים מע״מ אלא אם צוין.",
      "המשקל הסופי יחושב לפי תעודת השקילה. פחת אינו מחויב.",
      "ההצעה בתוקף ל-{{days}} ימים ממועד הפקתה."
    ],
    "customerSign": "חתימת הלקוח ואישור ההצעה",
    "footer": "הופק באמצעות EasyBar · easybar.co.il",
    "send": "שליחת הצעת מחיר",
    "phone": "טלפון לוואטסאפ",
    "email": "מייל",
    "message": "הודעה",
    "allowApproval": "הלקוח יוכל לאשר את ההצעה בקישור - ההזמנה תעבור ל״בייצור״",
    "sendEmail": "שלח במייל",
    "sendWhatsapp": "שלח בוואטסאפ",
    "sent": "ההצעה נשלחה"
  },
  "common": {
    "close": "סגור",
    "cancel": "ביטול",
    "edit": "עריכה",
    "restore": "שחזר",
    "loading": "טוען...",
    "error": "לא הצלחנו לטעון את המחירון",
    "delete": "מחיקה"
  },
  "nav": "מחירון"
};
